
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"64","height":"64","fill":"#400F3F","rx":"8.258"}}),_c('g',{attrs:{"transform":"rotate(-90 32 14.452)"}},[_c('rect',{attrs:{"width":"28.903","height":"6.194","fill":"#661A32","rx":"1.548"}}),_c('rect',{attrs:{"width":"28.903","height":"6.194","y":"11.355","fill":"#330C32","rx":"3.097"}}),_c('rect',{attrs:{"width":"28.903","height":"6.194","y":"22.71","fill":"#661A32","rx":"1.548"}}),_c('g',{attrs:{"fill":"#FF4702"}},[_c('rect',{attrs:{"width":"20.645","height":"6.194","rx":"1.548"}}),_c('rect',{attrs:{"width":"28.903","height":"6.194","y":"11.355","rx":"1.548"}}),_c('rect',{attrs:{"width":"12.387","height":"6.194","y":"22.71","rx":"1.548"}})])])])])
          )
        }
      }
    